// extracted by mini-css-extract-plugin
export default {"title":"d2e2b1dfb4","bld":"_8be2052511"};